interface Props {
  children: React.ReactNode;
  tone?: 'default' | 'core' | 'addon';
}
export function Badge({ children, tone = 'default' }: Props) {
  const cls = {
    default: 'bg-arcforge-100 text-arcforge-700',
    core: 'bg-blue-100 text-blue-700',
    addon: 'bg-emerald-100 text-emerald-700',
  }[tone];
  return (
    <span className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${cls}`}>
      {children}
    </span>
  );
}
